import { ReactElement } from "react";
import { useIndicators } from "../../../hooks/UseIndicators";
import { IComponent } from "../../../services/http/component/models/IComponent";
import { className } from "../../../shared/helpers";
import styles from "./StatusIndicator.module.scss";

interface StatusIndicatorProps
{
    component: IComponent;
    customClassName?: string;
    inverted?: boolean;
    hideDot?: boolean;
}

const StatusIndicator = (props: StatusIndicatorProps): ReactElement =>
{
    const { hasNoIndicators, indicatorStatus } = useIndicators(props.component);

    return (
        <div
            {...className(styles.statusIndicator, props.customClassName, {
                [styles.inverted]: props.inverted
            })}
        >
            {!hasNoIndicators && (
                <>
                    {!props.hideDot && <span {...className(styles.dot, indicatorStatus.className)} />}

                    <span className={styles.score} style={{ color: indicatorStatus.color }}>
                        {indicatorStatus.text}
                    </span>
                </>
            )}

            {hasNoIndicators && <span className={styles.noData}>N/A</span>}
        </div>
    );
};

export default StatusIndicator;
